export const getFabricPriceSlabList = state => {
    return state.list
}

export const getFabricPriceSlabDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/fabricPriceSlab/getters.js